import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Header({ langKey }: any) {
    const { useLang, useEffect, useState } = useGlobal();
    const { t } = useLang(langKey || 'poweroceancollection');
    const [top, setTop] = useState(0);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const target = document.querySelector('.collection-header') as HTMLElement;
            if (target) {
                setTimeout(() => {
                    target.classList.add('gray');
                }, 2000);
            }
            const naver = document.querySelector('.product_naver') as HTMLElement;
            if (naver) {
                setTop(naver?.offsetHeight);
            }
        }
    }, []);

    return (
        <header className={`collection-header ${css.header}`} style={{ top: `${top}px` }}>
            <div className="header-content">
                <span className="header-text">{t('header_text')}</span>
            </div>
        </header>
    );
}
